/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from 'antd';
import classNames from 'classnames';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DropTarget } from 'react-dnd';
import IconCameraOff from '../../assets/icons/camera_off.svg';
import IconCameraOn from '../../assets/icons/camera_on.svg';
import CardDnd from '../../components/CardDnd';
import CameraSettingPopup from './CameraSettingPopup';
import { HistoryEventsModal } from './HistoryEventsModal';
import { ServicesModal } from './ServicesModal';

const sortByName = (a, b) => {
  if (a?.name < b?.name) {
    return -1;
  }

  if (a?.name > b?.name) {
    return 1;
  }

  return 0;
};

const DndCameraComponent = ({
  connectDropTarget,
  data,
  owner,
  handleUpdateCamera,
  handleUpdateStream,
  handleRemoveDevice,
  current,
  setSelect,
}) => {
  const ref = useRef(null);
  const [cameras, setCameras] = useState(data || []);
  const [visibleDetail, setVisibleDetail] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataCameraEvent, setDataCameraEvent] = useState();
  const [isModalVisibleService, setIsModalVisibleService] = useState(false);
  const [dataServiceCamera, setDataServiceCamera] = useState();
  useEffect(() => {
    setCameras(data || []);
  }, [data]);

  const findCard = useCallback(
    (serial) => {
      const camera = cameras.filter((c) => `${c.serial}` === serial)[0];
      return {
        camera,
        index: cameras.indexOf(camera),
      };
    },
    [cameras]
  );
  const moveCard = useCallback(
    (serial, atIndex) => {
      const { camera, index } = findCard(serial);
      setCameras(
        update(cameras, {
          $splice: [
            [index, 1],
            [atIndex, 0, camera],
          ],
        })
      );
    },
    [cameras, findCard]
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOkService = () => {
    setIsModalVisibleService(false);
  };

  const handleCancelService = () => {
    setIsModalVisibleService(false);
  };

  connectDropTarget(ref);
  return (
    <div ref={ref}>
      {(cameras || []).sort(sortByName).map((camera, index) => (
        <CardDnd
          key={camera.serial}
          id={`${camera.serial}`}
          moveCard={moveCard}
          findCard={findCard}
        >
          <div
            key={camera.serial}
            className={classNames('child-pin-camera', {
              selected: current && camera.serial === current.serial,
            })}
          >
            <div
              onClick={() => {
                setSelect(camera);
              }}
              className="info-side"
            >
              <div className="name">
                <div className="cam-icon">
                  <img
                    src={camera.state === 1 ? IconCameraOn : IconCameraOff}
                    alt="camera on"
                    className="camera-icon"
                  />
                </div>
                <Tooltip title={`${camera.name}`}>
                  <div className="cam-name cam-name-text">{` ${camera.name}`}</div>
                </Tooltip>
              </div>
            </div>
            <CameraSettingPopup
              camera={camera}
              isVisible={camera?.serial === visibleDetail}
              setVisibleDetail={setVisibleDetail}
              owner={owner}
              handleUpdateStream={handleUpdateStream}
              onClickEditButton={() => {
                setVisibleDetail(null);
                handleUpdateCamera(camera);
              }}
              onClickHistoryEvent={() => {
                showModal();
                setVisibleDetail(null);
                setDataCameraEvent(camera);
              }}
              onClickServiceDetail={() => {
                setIsModalVisibleService(true);
                setVisibleDetail(null);
                setDataServiceCamera(camera);
              }}
              onClickDeleteButton={() => {
                setVisibleDetail(null);
                handleRemoveDevice(camera.name, camera.serial);
              }}
            />
          </div>
        </CardDnd>
      ))}
      <HistoryEventsModal
        title={dataCameraEvent?.name}
        data={dataCameraEvent}
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
      <ServicesModal
        title={dataServiceCamera?.name}
        isVisible={isModalVisibleService}
        handleOk={handleOkService}
        handleCancel={handleCancelService}
        data={dataServiceCamera}
      />
    </div>
  );
};
export default DropTarget('card', {}, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(DndCameraComponent);
